import { render, staticRenderFns } from "./vueAvatar.vue?vue&type=template&id=3ea0e96a&scoped=true&"
import script from "./vueAvatar.vue?vue&type=script&lang=js&"
export * from "./vueAvatar.vue?vue&type=script&lang=js&"
import style0 from "./vueAvatar.vue?vue&type=style&index=0&id=3ea0e96a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea0e96a",
  null
  
)

export default component.exports